import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({providedIn: 'root'})
export class JitsyService {
  public closeCall$ = new BehaviorSubject<boolean | any>(false);
  public hungUp$ = new BehaviorSubject<boolean | any>(false);
  public update$ = new BehaviorSubject<boolean | any>(false);
  constructor() {
  }

}
